import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import aboutImg from '../assets/images/about-pellets.jpg';
import './About.css';

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="section about">
      <div className="container about__inner">
        <div className="about__media">
          <img src={aboutImg} alt="Plastic raw material granules" loading="lazy" />
        </div>
        <div className="about__content">
          <span className="kicker">{t.about.kicker}</span>
          <h2 className="section-title">{t.about.title}</h2>
          {t.about.paragraphs.map((p, i) => (
            <p className="about__paragraph" key={i}>
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}
